import { useTranslation } from 'react-i18next';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider as MUILocalizationProvider } from '@mui/x-date-pickers';
import { FC, ReactNode } from 'react';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';

interface LocalizationProviderProps {
    children: ReactNode;
}

const LocalizationProvider: FC<LocalizationProviderProps> = ({ children }) => {
    const { i18n } = useTranslation();

    return (
        <MUILocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n.language}>
            {children}
        </MUILocalizationProvider>
    );
};

export default LocalizationProvider;
